import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

interface ISpecificationsPopupProps {
  open: boolean;
  onClose(): void;
}

export function SpecificationsPopup({ open, children, onClose }: React.PropsWithChildren<ISpecificationsPopupProps>) {
  return <ModalWindow open={open} content={children} width={880} onClose={onClose} />;
}
